import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
//import { LoginPage } from '../../pages/login/login';

import { Events } from 'ionic-angular';

@Injectable()
export class RestProvider {
  //private apiUrl = 'https://restcountries.eu/rest/v2/all';

  //private apiUrl = 'http://plentyclip.apps/api';
  private apiUrl = 'http://api.picmasters.de.w016f694.kasserver.com/api'

  templateData: any;

  orders: any;


  constructor(private events:Events, public http: Http) {}

  getCountries(): Observable<string[]> {
    return this.http.get(this.apiUrl)
      .map(response => response.json())
      .catch(this.handleError);
  }


  // getUsers() {
  //   if (this.templateData) {
  //     return Promise.resolve(this.templateData);
  //   }

  //   return new Promise(resolve => {
  //     this.http.get(this.apiUrl+'/users')
  //       .map(res => res.json())
  //       .subscribe(data => {
  //         this.templateData = data;
  //         resolve(this.templateData);
  //       });
  //   });
  // }

  // saveUser(data) {
  //   return new Promise((resolve, reject) => {
  //     this.http.post(this.apiUrl+'/users', JSON.stringify(data))
  //       .subscribe(res => {
  //         resolve(res);
  //       }, (err) => {
  //         reject(err);
  //       });
  //   });
  // }



  public ping() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this.getToken());
    console.log('TOKEN!!!');
    console.log(this.getToken());
    let options = new RequestOptions({ headers: headers });

    this.http.get('http://plentyclip.apps/api/user', options)
      .subscribe(
        data => console.log(data),
        err => this.handleError(err)
      );
  }

  getOrders() {
    if (this.orders) {
      return Promise.resolve(this.orders);
    }

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this.getToken());
    let options = new RequestOptions({ headers: headers });

    return new Promise(resolve => {
      this.http.get(this.apiUrl+'/orders', options)
        .map(res => res.json())
        .subscribe(data => {
          this.orders = data;
          resolve(this.orders);
        });
    });
  }

  // public getOrders() {
  //   let headers = new Headers();
  //   headers.append('Content-Type', 'application/json');
  //   headers.append('Authorization', 'Bearer ' + this.getToken());
  //   console.log('TOKEN!!!');
  //   console.log(this.getToken());
  //   let options = new RequestOptions({ headers: headers });

  //   this.http.get('http://plentyclip.apps/api/user', options)
  //     .subscribe(
  //       data => console.log(data),
  //       err => this.handleError(err)
  //     );
  // }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const err = error || '';
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

      if (error.status === 401 || error.status === 403) {
       this.events.publish('user:logout');
     }

    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }



}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts